<template>
    <div id="alerts-configured-widget-component">
        <v-card class="elevation-0 overflow-visible">
            <v-card-title>
                <HeaderWidgetComponent
                    :actions="[
                        {
                            title: $t('list_tank_equipmement_component.manage_alert'),
                            icon: 'mdi-bell-outline',
                            emit: 'goToManageAlertPage',
                            has_access: userHasAccess('BASE', role_vision),
                        },
                    ]"
                    :is_open="is_open"
                    :title="$t('alerts_configured_component.alerts_parameter')"
                    widget_name="alerts-configured-component"
                    v-on:goToManageAlertPage="$router.push('/equipment/manage_alert/' + asset.id_asset)"
                />
            </v-card-title>

            <v-expand-transition>
                <div v-show="is_open">
                    <v-card-text class="pt-0 pb-4">
                        <alerts-list-component
                            :alerts="alerts"
                            :loading="loading_alerts"
                            v-on:refresh:alert="prepareFetchAlertsByAsset"
                        />
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>
    </div>
</template>

<script>
import HeaderWidgetComponent from './HeaderWidgetComponent.vue'
import DeviceRepository from '@/repositories/DeviceRepository'
import AlertsListComponent from '@/components/alert/containment/AlertsListComponent.vue'

export default {
    name: 'AlertsConfiguredWidgetComponent',
    components: { AlertsListComponent, HeaderWidgetComponent },
    created() {
        this.prepareFetchAlertsByAsset()
    },
    props: {
        is_open: {
            type: Boolean,
            required: false,
            default: false,
        },
        asset: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            alerts: [],
            loading_alerts: false,
        }
    },
    methods: {
        async prepareFetchAlertsByAsset() {
            this.loading_alerts = true
            this.alerts = []
            await Promise.all(
                this.asset.devices.map((device) => {
                    return Promise.resolve(this.fetchAlertsByDevice(device.id_device))
                })
            ).finally(() => {
                this.loading_alerts = false
            })
        },
        fetchAlertsByDevice(id_device) {
            return DeviceRepository.getAllAlertByIdDevice(id_device)
                .then((success) => {
                    success.data.data.forEach((alert) => {
                        this.alerts.push(alert)
                    })
                })
                .catch((error) => {
                    this.manageError(error)
                })
        },
    },
}
</script>
